/**
 * The type of Redux action triggering storage of participantId of transcriber,
 * so that it can later be kicked
 *
 * {
 *     type: TRANSCRIBER_JOINED,
 *     participantId: String
 * }
 * @private
 */
export const TRANSCRIBER_JOINED = 'TRANSCRIBER_JOINED';
/**
 * The type of Redux action signalling that the transcriber has left
 *
 * {
 *     type: TRANSCRIBER_LEFT,
 *     participantId: String
 * }
 * @private
 */
export const TRANSCRIBER_LEFT = 'TRANSCRIBER_LEFT';
/**
 * The type of Redux action signalling that a potential transcriber has joined.
 * Preserved for 11sight compatibility.
 *
 * {
 *     type: _POTENTIAL_TRANSCRIBER_JOINED,
 *     transcriberJID: string
 * }
 * @private
 */
export const _POTENTIAL_TRANSCRIBER_JOINED = '_POTENTIAL_TRANSCRIBER_JOINED';
/**
 * The type of Redux action signalling that the transcriber has joined (internal use).
 * Preserved for 11sight compatibility.
 *
 * {
 *     type: _TRANSCRIBER_JOINED,
 *     participantId: string
 * }
 * @private
 */
export const _TRANSCRIBER_JOINED = '_TRANSCRIBER_JOINED';
/**
 * The type of Redux action signalling that the transcriber has left (internal use).
 * Preserved for 11sight compatibility.
 *
 * {
 *     type: _TRANSCRIBER_LEFT,
 *     participantId: string
 * }
 * @private
 */
export const _TRANSCRIBER_LEFT = '_TRANSCRIBER_LEFT';
/**
 * The type of Redux action which sets the pending transcribing notification UID.
 * Preserved for 11sight compatibility.
 *
 * {
 *     type: SET_PENDING_TRANSCRIBING_NOTIFICATION_UID,
 *     uid: string | undefined
 * }
 */
export const SET_PENDING_TRANSCRIBING_NOTIFICATION_UID = 'SET_PENDING_TRANSCRIBING_NOTIFICATION_UID';
